import type { RiskEventAPI } from './APITypes';
import type { RiskEvent } from './Types';

import { dateTimeStrToMilli } from '../../formatters/dateTimeFormat';

export const toRiskEvent = (riskEventAPI: RiskEventAPI): RiskEvent => ({
  eventType: riskEventAPI.event_id,
  eventTimestamp: dateTimeStrToMilli(riskEventAPI.event_time),
  deviceType: riskEventAPI.device_type,
  latitude: riskEventAPI.latitude,
  longitude: riskEventAPI.longitude,
});

export default toRiskEvent;
